import { AfterContentChecked, AfterContentInit, Directive, ElementRef, inject } from '@angular/core';
import { Panel as PanelService } from '../panel.svc';

/**
 * @description This directive is meant to be attached to a heading tag
 *   in the OkePanel's _header_ element. That heading tag can be a
 *   direct child of the OkePanelHeader element, or of the
 *   `okePanelCollapsible` element. This directive adds the appropriate
 *   className and stores the title's text content
 */
@Directive({
  selector: '[okePanelTitle]'
})
export class Title implements AfterContentInit, AfterContentChecked {
  private readonly _panelSvc: PanelService = inject(PanelService, {
    host: true
  });
  private readonly _elem: ElementRef = inject(ElementRef);

  constructor() {
    this._elem.nativeElement.classList.add('title');
  }

  ngAfterContentInit(): void {
    if (!this._elem) {
      return;
    }
    this._panelSvc.updateState('header', {
      title: this._elem.nativeElement.textContent
    });
  }

  ngAfterContentChecked(): void {
    if (!(this._elem && !this._panelSvc.$state().header.projected)) {
      return;
    }
    this._panelSvc.updateState('header', {
      title: this._elem.nativeElement.textContent
    });
  }
}
